import { Constants as NavigationConstants } from '~/components/Navigation/constants';
import { Constants as NavigationBarConstants } from '~/components/NavigationBar/constants';
import { miniPlayerHeight } from '~/components/Player/MiniPlayer/styles';
import { BP, mq } from '~/styles';
import type { TStyleSheet } from '~/types/emotion-styles';

export const Constants = {
  paddingTopSm: NavigationBarConstants.barHeight,
  paddingTopLg: NavigationConstants.navPadding[BP.Large],
  minMainHeight: '85vh',
  layoutPadding: {
    SM: 40,
    MD: 40,
    LG: 60,
    back: 20,
  },
};

const styles: TStyleSheet = {
  container: {
    [mq(BP.Large)]: {
      display: 'flex',
    },
  },
  back: {
    marginLeft: 0,
    marginBottom: 40,
    [mq(BP.Medium)]: {
      marginLeft: 26,
    },
  },
  backButtonPadding: {
    paddingTop: Constants.layoutPadding.back,
  },
  body: {
    padding: `${Constants.paddingTopSm}px 0 20px`,
    width: '100%',
    // Using 'overflow: hidden' to horizontally cut off carousels to avoid the site
    // from getting a horizontal scroll bar. This clashes with 'position: sticky' used
    // for tabs on MyAudioPage and StationSchedulePage, therefore we temporarily adjust
    // overflow to be `overflow: visible` for these.
    // TODO: [A2-5844] Revisit overflow: hidden on <Layout> component
    overflow: 'hidden',
    maxWidth: '100vw',
    [mq(BP.Large)]: {
      padding: 0,
      marginLeft: NavigationConstants.menuWidth[BP.Large],
      width: `calc(100% - ${NavigationConstants.menuWidth[BP.Large]}px)`,
    },
  },
  main: {
    display: 'block',
    minHeight: `calc(${Constants.minMainHeight} - ${Constants.paddingTopSm}px)`,
    paddingTop: Constants.layoutPadding.SM,
    [mq(BP.Medium)]: {
      paddingTop: Constants.layoutPadding.MD,
    },
    [mq(BP.Large)]: {
      minHeight: Constants.minMainHeight,
      paddingTop: Constants.layoutPadding.LG,
    },
  },
  // entity pages have a toolbar with less top spacing and potentially have a hero image that requires no top spacing so reset padding here
  resetTopPadding: {
    [mq(BP.Small)]: {
      paddingTop: 0,
    },
    [mq(BP.Medium)]: {
      paddingTop: 0,
    },
    [mq(BP.Large)]: {
      paddingTop: 0,
    },
  },
  mainPadding: {
    paddingBottom: 120,
  },
  playerVisible: {
    paddingBottom: miniPlayerHeight[BP.Small],
    [mq(BP.Medium)]: {
      paddingBottom: miniPlayerHeight[BP.Medium],
    },
    [mq(BP.Large)]: {
      paddingBottom: `calc(${miniPlayerHeight[BP.Medium]}px + 30px)`,
    },
  },
};

export default styles;
